import type Action from 'constants/action-types'
import {
  SET_TIME_RANGE,
  SET_DATE_FILTER,
  ADD_ATTRIBUTE_VALUE_FILTER,
  REMOVE_ATTRIBUTE_VALUE_FILTER,
  CLEAR_ATTRIBUTE_VALUE_FILTERS,
} from 'constants/action-types'
import { TimeRange, type FiltersState } from 'types/search/filters'
import { isDemoMode } from 'lib/is-demo'

const initialState: FiltersState = {
  timeRange: isDemoMode ? TimeRange.ONE_DAY : TimeRange.TEN_MIN,
  customDateRange: {
    startDate: null,
    endDate: null,
  },
  attributeValues: [],
}

const filtersReducer = (
  state: FiltersState = initialState,
  action: Action,
): FiltersState => {
  switch (action.type) {
    case SET_TIME_RANGE:
      return {
        ...state,
        timeRange: action.payload,
      }

    case SET_DATE_FILTER:
      return {
        ...state,
        customDateRange: action.payload,
      }

    case ADD_ATTRIBUTE_VALUE_FILTER: {
      // Check if filter already exists
      const exists = state.attributeValues.some(
        (filter) =>
          filter.attributeCode === action.payload.attributeCode &&
          filter.value === action.payload.value,
      )
      if (exists) {
        return state
      }
      return {
        ...state,
        attributeValues: [...state.attributeValues, action.payload],
      }
    }
    case REMOVE_ATTRIBUTE_VALUE_FILTER:
      return {
        ...state,
        attributeValues: state.attributeValues.filter(
          (filter) =>
            !(
              filter.attributeCode === action.payload.attributeCode &&
              filter.value === action.payload.value
            ),
        ),
      }

    case CLEAR_ATTRIBUTE_VALUE_FILTERS:
      return {
        ...state,
        attributeValues: [],
      }

    default:
      return state
  }
}

export default filtersReducer
